import { Environment } from '@thiememeulenhoff/types';
import { toegangClientSecret } from '@thiememeulenhoff/ng-sdk';
import { EnvironmentType } from './environment.type';

export const environment: EnvironmentType = {
  environment: Environment.Production,
  vestaUrl: 'https://vesta.thiememeulenhoff.nl/admin',
  unleash: {
    instance: 'eu.app.unleash-hosted.com/euee0007',
    clientKey:
      '*:production.5f8928ceb399f8c72cd7e889f7c11193ee173f652b5595c5c1a71d38',
    environment: 'production',
    refreshInterval: 5 * 60, // 5 minutes
    metricsInterval: 15 * 60, // 15 minutes
  },
  auth: {
    environment: Environment.Production,
    clientId: 'edu-admin',
    clientSecret: toegangClientSecret('EDU_ADMIN'),
    useUserCookie: false,
  },
  tham: {
    proxyDomain: 'https://d3c9bg8z45r18r.cloudfront.net',
  },
};
